export const planetsData = [
  {
    id: 1,
    name: 'Sun',
    symbol: '☉',
    emoji: '☀️',
    image: '/img/sun.jpeg',
    color: 'rgb(212 204 187)',
    element: 'Fire',
    day: 'Sunday',
    description: 'The Sun represents vitality, ego, soul, power, and authority. It governs leadership, confidence, and life force energy.',
    longDescription: 'The Sun is the king of all planets in Vedic astrology, representing the soul, vitality, and life force. It governs our sense of self, confidence, leadership abilities, and relationship with authority figures, especially the father. A strong Sun bestows courage, independence, and success in positions of power.',
    properties: [
      'Governs vitality and life force',
      'Represents father and authority figures',
      'Controls ego and self-confidence',
      'Influences career and social status',
      'Rules leadership and governmental affairs'
    ],
    benefits: [
      'Enhanced confidence and willpower',
      'Success in leadership roles',
      'Improved health and vitality',
      'Better relationship with father',
      'Recognition and fame'
    ],
    bestStone: {
      name: 'Sunstone',
      emoji: '🌟',
      image: "/img/sunstone.jpeg", 
      price: null, 
      description: 'The premier stone for Sun energy, Sunstone radiates warmth, vitality, and life force. It embodies all the positive attributes of the Sun.',
      properties: ['Leadership', 'Vitality', 'Confidence', 'Success'],
      benefits: [
        'Enhances natural leadership abilities',
        'Boosts physical energy and stamina',
        'Increases self-confidence and charisma',
        'Attracts success and recognition',
        'Improves relationship with authority'
      ],
      wearingInstructions: 'Wear on ring finger of right hand, set in gold, on Sunday morning during sunrise.',
      mantra: 'Om Suryaya Namaha'
    },
    otherStones: [
      {
        name: 'Red Garnet',
        emoji: '🔴',
        description: 'A powerful alternative that channels Sun\'s fiery energy through deep red vibrations.',
        properties: ['Energy', 'Passion', 'Strength'],
        recommendedFor: 'Those who need grounding along with vitality'
      },
      {
        name: 'Red Jasper',
        emoji: '💎',
        description: 'Earthy stone that provides stable Sun energy, excellent for sustained vitality.',
        properties: ['Endurance', 'Stability', 'Protection'],
        recommendedFor: 'Those needing steady, long-lasting energy'
      },
      {
        name: 'Pyrite',
        emoji: '⭐',
        description: 'Known as "Fool\'s Gold", it attracts abundance and mirrors Sun\'s golden energy.',
        properties: ['Wealth', 'Protection', 'Confidence'],
        recommendedFor: 'Business owners and entrepreneurs'
      }
    ]
  },
  {
    id: 2,
    name: 'Moon',
    symbol: '☽',
    emoji: '🌙',
    image: '/img/moon.jpeg',
    color: 'rgb(212 204 187)',
    element: 'Water',
    day: 'Monday',
    description: 'The Moon represents mind, emotions, mother, intuition, and inner peace. It governs mental stability and emotional well-being.',
    longDescription: 'The Moon is the queen of the planetary cabinet, governing our mind, emotions, and subconscious. It represents our mother, emotional nature, intuition, and mental peace. A strong Moon provides emotional stability, good memory, nurturing abilities, and psychic sensitivity.',
    properties: [
      'Governs mind and emotions',
      'Represents mother and nurturing',
      'Controls memory and intuition',
      'Influences mental health',
      'Rules over water and fluids'
    ],
    benefits: [
      'Enhanced emotional stability',
      'Better mental clarity',
      'Improved intuition',
      'Peaceful mind',
      'Strong maternal bonds'
    ],
    bestStone: {
      name: 'Moonstone',
      emoji: '🌙',
      image: "/img/moonstone.jpeg",
      price: null,
      description: 'The quintessential Moon gem, Moonstone reflects lunar energy with its ethereal glow. Perfect for emotional balance and intuition.',
      properties: ['Intuition', 'Peace', 'Balance', 'Femininity'],
      benefits: [
        'Calms emotional turbulence',
        'Enhances intuitive abilities',
        'Improves mental clarity',
        'Strengthens maternal relationships',
        'Promotes restful sleep and dreams'
      ],
      wearingInstructions: 'Wear on ring finger or little finger of right hand, set in silver, on Monday during moonrise.',
      mantra: 'Om Chandraya Namaha'
    },
    otherStones: [
      {
        name: 'White Quartz',
        emoji: '⚪',
        description: 'Crystal clear energy amplifier that channels pure lunar vibrations.',
        properties: ['Clarity', 'Amplification', 'Purity'],
        recommendedFor: 'Those seeking mental clarity and peace'
      },
      {
        name: 'Selenite',
        emoji: '🤍',
        description: 'Named after Selene, goddess of the Moon, it provides divine lunar connection.',
        properties: ['Cleansing', 'Spiritual', 'Protection'],
        recommendedFor: 'Spiritual seekers and healers'
      }
    ]
  },
  {
    id: 3,
    name: 'Mars',
    symbol: '♂',
    emoji: '🔴',
    image: '/img/mars.jpeg',
    color: 'rgb(212 204 187)',
    element: 'Fire',
    day: 'Tuesday',
    description: 'Mars represents energy, courage, strength, brothers, and competition. It governs physical power and fighting spirit.',
    longDescription: 'Mars is the warrior planet, representing courage, energy, passion, and physical strength. It governs our fighting spirit, competitive nature, brothers, and property. A strong Mars provides bravery, athletic ability, technical skills, and success in competitive fields.',
    properties: [
      'Governs courage and bravery',
      'Represents brothers and siblings',
      'Controls physical energy',
      'Influences property and land',
      'Rules combat and competition'
    ],
    benefits: [
      'Increased physical strength',
      'Enhanced courage and bravery',
      'Success in competition',
      'Better sibling relationships',
      'Victory over enemies'
    ],
    bestStone: {
      name: 'Red Jasper',
      emoji: '🔴',
      image: "/img/marstone.jpeg",
      price: null,
      description: 'The ultimate Mars stone, Red Jasper embodies warrior energy with grounding stability. Perfect for sustained courage and strength.',
      properties: ['Courage', 'Strength', 'Endurance', 'Protection'],
      benefits: [
        'Boosts physical stamina and energy',
        'Increases courage in facing challenges',
        'Provides protection from accidents',
        'Enhances athletic performance',
        'Improves focus and determination'
      ],
      wearingInstructions: 'Wear on ring finger of right hand, set in gold or copper, on Tuesday morning.',
      mantra: 'Om Mangalaya Namaha'
    },
    otherStones: [
      {
        name: 'Carnelian',
        emoji: '🧡',
        description: 'Vibrant stone that ignites Mars energy with passionate vitality.',
        properties: ['Motivation', 'Creativity', 'Action'],
        recommendedFor: 'Creative professionals and performers'
      },
      {
        name: 'Bloodstone',
        emoji: '💚',
        description: 'Ancient warrior stone that combines courage with healing energy.',
        properties: ['Warrior Spirit', 'Healing', 'Vitality'],
        recommendedFor: 'Athletes and military personnel'
      },
      {
        name: 'Pyrite',
        emoji: '⭐',
        description: 'Provides Mars energy with added protection and abundance.',
        properties: ['Protection', 'Abundance', 'Willpower'],
        recommendedFor: 'Those facing competition in business'
      }
    ]
  },
  {
    id: 4,
    name: 'Mercury',
    symbol: '☿',
    emoji: '💚',
    image: '/img/mercury.jpeg',
    color: 'rgb(212 204 187)',
    element: 'Earth',
    day: 'Wednesday',
    description: 'Mercury represents intellect, communication, business, and education. It governs speech, writing, and analytical abilities.',
    longDescription: 'Mercury is the prince of the planetary cabinet, governing intelligence, communication, commerce, and education. It represents our intellect, speech, business acumen, and ability to learn. A strong Mercury provides excellent communication skills, sharp intellect, business success, and mathematical abilities.',
    properties: [
      'Governs intellect and speech',
      'Represents business and trade',
      'Controls communication skills',
      'Influences education and learning',
      'Rules mathematics and analysis'
    ],
    benefits: [
      'Enhanced intelligence',
      'Improved communication',
      'Success in business',
      'Better learning abilities',
      'Sharp analytical mind'
    ],
    bestStone: {
      name: 'Green Aventurine',
      emoji: '💚',
      image: "/img/mercurystone.jpeg",
      price: null,
      description: 'The premier Mercury stone, Green Aventurine enhances communication, intellect, and brings business prosperity.',
      properties: ['Intelligence', 'Communication', 'Prosperity', 'Opportunity'],
      benefits: [
        'Sharpens mental clarity and focus',
        'Enhances verbal and written communication',
        'Attracts business opportunities',
        'Improves memory and learning',
        'Brings success in competitive exams'
      ],
      wearingInstructions: 'Wear on little finger or ring finger, set in gold or silver, on Wednesday morning.',
      mantra: 'Om Budhaya Namaha'
    },
    otherStones: [
      {
        name: 'Peridot',
        emoji: '💎',
        description: 'Bright green stone that amplifies Mercury\'s intellectual gifts.',
        properties: ['Clarity', 'Confidence', 'Communication'],
        recommendedFor: 'Public speakers and teachers'
      },
      {
        name: 'Green Jade',
        emoji: '🟢',
        description: 'Ancient wisdom stone combining Mercury\'s intelligence with prosperity.',
        properties: ['Wisdom', 'Harmony', 'Abundance'],
        recommendedFor: 'Business owners and merchants'
      },
      {
        name: 'Emerald',
        emoji: '💚',
        description: 'Premium Mercury gem for maximum intellectual and business benefits.',
        properties: ['Brilliance', 'Eloquence', 'Success'],
        recommendedFor: 'High-level professionals and executives'
      }
    ]
  },
  {
    id: 5,
    name: 'Jupiter',
    symbol: '♃',
    emoji: '💛',
    image: '/img/jupiter.jpeg',
    color: 'rgb(212 204 187)',
    element: 'Ether',
    day: 'Thursday',
    description: 'Jupiter represents wisdom, fortune, expansion, and spiritual knowledge. It governs wealth, education, and divine grace.',
    longDescription: 'Jupiter is the guru (teacher) of gods, representing wisdom, prosperity, spirituality, and divine grace. It governs higher education, philosophy, children, wealth, and fortune. A strong Jupiter bestows wisdom, prosperity, spiritual inclination, and success in teaching or spiritual fields.',
    properties: [
      'Governs wisdom and knowledge',
      'Represents wealth and fortune',
      'Controls higher education',
      'Influences children and progeny',
      'Rules religion and spirituality'
    ],
    benefits: [
      'Enhanced wisdom and judgment',
      'Financial prosperity',
      'Success in education',
      'Spiritual growth',
      'Blessed with children'
    ],
    bestStone: {
      name: 'Yellow Citrine',
      emoji: '💛',
      image: "/img/jupiterstone.jpeg",
      price: null,
      description: 'The ultimate Jupiter stone, Yellow Citrine attracts abundance, wisdom, and divine blessings.',
      properties: ['Wisdom', 'Abundance', 'Fortune', 'Spirituality'],
      benefits: [
        'Attracts wealth and prosperity',
        'Enhances wisdom and judgment',
        'Brings divine grace and blessings',
        'Improves luck and fortune',
        'Success in higher education'
      ],
      wearingInstructions: 'Wear on index finger of right hand, set in gold, on Thursday morning.',
      mantra: 'Om Gurave Namaha'
    },
    otherStones: [
      {
        name: 'Yellow Quartz',
        emoji: '🟡',
        description: 'Clear yellow energy that channels Jupiter\'s expansive abundance.',
        properties: ['Expansion', 'Clarity', 'Optimism'],
        recommendedFor: 'Entrepreneurs and investors'
      },
      {
        name: 'Yellow Jasper',
        emoji: '✨',
        description: 'Grounded Jupiter energy for steady wealth accumulation.',
        properties: ['Stability', 'Perseverance', 'Protection'],
        recommendedFor: 'Long-term wealth building'
      },
      {
        name: 'Pyrite',
        emoji: '⭐',
        description: 'Golden abundance stone that mirrors Jupiter\'s prosperity.',
        properties: ['Wealth', 'Manifestation', 'Success'],
        recommendedFor: 'Business and finance professionals'
      }
    ]
  },
  {
    id: 6,
    name: 'Venus',
    symbol: '♀',
    emoji: '💗',
    image: '/img/venus.jpeg',
    color: 'rgb(212 204 187)',
    element: 'Water',
    day: 'Friday',
    description: 'Venus represents love, beauty, luxury, and creativity. It governs relationships, arts, and material comforts.',
    longDescription: 'Venus is the goddess of love and beauty, representing romance, aesthetics, luxury, and artistic talents. It governs marriage, relationships, vehicles, and material comforts. A strong Venus provides beauty, charm, artistic abilities, harmonious relationships, and appreciation for luxuries.',
    properties: [
      'Governs love and relationships',
      'Represents beauty and aesthetics',
      'Controls luxury and comforts',
      'Influences arts and creativity',
      'Rules marriage and partnership'
    ],
    benefits: [
      'Attracts love and romance',
      'Enhanced beauty and charm',
      'Artistic success',
      'Harmonious relationships',
      'Material luxuries'
    ],
    bestStone: {
      name: 'Rose Quartz',
      emoji: '💗',
      image: "/img/venustone.jpeg",
      price: null,
      description: 'The ultimate love stone, Rose Quartz embodies Venus\'s gentle, loving, and harmonious energy.',
      properties: ['Love', 'Beauty', 'Harmony', 'Compassion'],
      benefits: [
        'Attracts romantic love and relationships',
        'Enhances physical beauty and charm',
        'Brings harmony to relationships',
        'Increases artistic creativity',
        'Promotes self-love and acceptance'
      ],
      wearingInstructions: 'Wear on little finger or middle finger, set in silver or white gold, on Friday morning.',
      mantra: 'Om Shukraya Namaha'
    },
    otherStones: [
      {
        name: 'White Quartz',
        emoji: '🤍',
        description: 'Pure Venus energy for clarity in love and relationships.',
        properties: ['Purity', 'Clarity', 'Balance'],
        recommendedFor: 'Those seeking clear romantic partnerships'
      },
      {
        name: 'Opalite',
        emoji: '✨',
        description: 'Ethereal stone that enhances Venus\'s romantic and creative gifts.',
        properties: ['Romance', 'Creativity', 'Transitions'],
        recommendedFor: 'Artists and creative professionals'
      }
    ]
  },
  {
    id: 7,
    name: 'Saturn',
    symbol: '♄',
    emoji: '💜',
    image: '/img/saturn.jpeg',
    color: 'rgb(212 204 187)',
    element: 'Air',
    day: 'Saturday',
    description: 'Saturn represents discipline, karma, hard work, and longevity. It governs justice, responsibilities, and life lessons.',
    longDescription: 'Saturn is the taskmaster of the zodiac, representing discipline, karma, hard work, and life lessons. It governs our sense of duty, responsibilities, limitations, and the aging process. A strong Saturn provides discipline, patience, longevity, and ultimate success through sustained effort.',
    properties: [
      'Governs discipline and duty',
      'Represents karma and justice',
      'Controls longevity and time',
      'Influences hard work and effort',
      'Rules limitations and obstacles'
    ],
    benefits: [
      'Enhanced discipline and focus',
      'Karmic clearing',
      'Long life and health',
      'Ultimate success through effort',
      'Spiritual maturity'
    ],
    bestStone: {
      name: 'Amethyst',
      emoji: '💜',
      image: "/img/saturnstone.jpeg",
      price: null,
      description: 'The premier Saturn stone, Amethyst brings discipline, spiritual wisdom, and protection through challenging times.',
      properties: ['Discipline', 'Wisdom', 'Protection', 'Spirituality'],
      benefits: [
        'Increases discipline and patience',
        'Provides protection from negative karma',
        'Enhances spiritual awareness',
        'Brings clarity in difficult times',
        'Promotes sobriety and clear thinking'
      ],
      wearingInstructions: 'Wear on middle finger of right hand, set in silver or iron, on Saturday evening.',
      mantra: 'Om Shanaye Namaha'
    },
    otherStones: [
      {
        name: 'Blue Quartz',
        emoji: '🔵',
        description: 'Calming Saturn energy that eases restrictions and brings clarity.',
        properties: ['Calmness', 'Order', 'Clarity'],
        recommendedFor: 'Those facing Saturn\'s testing periods'
      },
      {
        name: 'Iolite',
        emoji: '💎',
        description: 'Vision stone that helps navigate Saturn\'s karmic lessons.',
        properties: ['Vision', 'Intuition', 'Direction'],
        recommendedFor: 'Spiritual seekers and those in transition'
      }
    ]
  },
  {
    id: 8,
    name: 'Rahu',
    symbol: '☊',
    emoji: '🖤',
    image: '/img/rahu.jpeg',
    color: 'rgb(212 204 187)',
    element: 'Air',
    day: 'Saturday',
    description: 'Rahu represents worldly desires, illusion, foreign influences, and sudden changes. It governs ambition and unconventional paths.',
    longDescription: 'Rahu is the North Node of the Moon, representing worldly desires, illusions, sudden changes, and foreign influences. It governs ambition, unconventional paths, technology, and material pursuits. A balanced Rahu provides success in foreign lands, technical skills, and fulfillment of worldly desires.',
    properties: [
      'Governs worldly ambitions',
      'Represents illusion and confusion',
      'Controls foreign connections',
      'Influences sudden changes',
      'Rules unconventional paths'
    ],
    benefits: [
      'Success in foreign lands',
      'Technological advancement',
      'Material success',
      'Breaking limitations',
      'Unique opportunities'
    ],
    bestStone: {
      name: 'Smoky Quartz',
      emoji: '🖤',
      image: "/img/rahustone.jpeg",
      price: null,
      description: 'The best stone for Rahu, Smoky Quartz grounds chaotic energy, removes confusion, and protects from negative influences.',
      properties: ['Grounding', 'Protection', 'Clarity', 'Transformation'],
      benefits: [
        'Grounds excessive Rahu energy',
        'Removes mental confusion and illusions',
        'Protects from negative influences',
        'Brings clarity to ambitions',
        'Success in unconventional careers'
      ],
      wearingInstructions: 'Wear on middle finger of right hand, set in silver or panchdhatu, on Saturday evening.',
      mantra: 'Om Rahuve Namaha'
    },
    otherStones: [
      {
        name: 'Labradorite',
        emoji: '✨',
        description: 'Mystical stone that helps harness Rahu\'s transformative power.',
        properties: ['Transformation', 'Magic', 'Protection'],
        recommendedFor: 'Those in technology and innovation'
      },
      {
        name: 'Black Onyx',
        emoji: '⚫',
        description: 'Strong protection stone that grounds Rahu\'s chaotic influence.',
        properties: ['Protection', 'Strength', 'Grounding'],
        recommendedFor: 'Those experiencing sudden changes'
      }
    ]
  },
  {
    id: 9,
    name: 'Ketu',
    symbol: '☋',
    emoji: '🟤',
    image: '/img/ketu.jpeg',
    color: 'rgb(212 204 187)',
    element: 'Fire',
    day: 'Tuesday',
    description: 'Ketu represents spirituality, detachment, liberation, and past-life karma. It governs mystical experiences and enlightenment.',
    longDescription: 'Ketu is the South Node of the Moon, representing spirituality, detachment, liberation, and past-life karma. It governs mystical experiences, psychic abilities, and the path to enlightenment. A balanced Ketu provides spiritual wisdom, intuitive abilities, and freedom from material attachments.',
    properties: [
      'Governs spirituality and detachment',
      'Represents past-life karma',
      'Controls psychic abilities',
      'Influences liberation (moksha)',
      'Rules mystical experiences'
    ],
    benefits: [
      'Spiritual enlightenment',
      'Psychic development',
      'Freedom from attachments',
      'Intuitive wisdom',
      'Karmic healing'
    ],
    bestStone: {
      name: "Tiger's Eye",
      emoji: '🟤',
      image: "/img/ketustone.jpeg",
      price: null,
      description: 'The premier Ketu stone, Tiger\'s Eye provides spiritual insight while maintaining grounding and protection.',
      properties: ['Insight', 'Protection', 'Grounding', 'Wisdom'],
      benefits: [
        'Enhances spiritual insight and intuition',
        'Provides protection during spiritual practices',
        'Balances material and spiritual life',
        'Helps release past-life karma',
        'Brings clarity to life purpose'
      ],
      wearingInstructions: 'Wear on ring finger or middle finger, set in silver or panchdhatu, on Tuesday or Thursday.',
      mantra: 'Om Ketave Namaha'
    },
    otherStones: [
      {
        name: "Cat's Eye Quartz",
        emoji: '👁️',
        description: 'Direct channel to Ketu\'s mystical and protective energy.',
        properties: ['Protection', 'Psychic Power', 'Awareness'],
        recommendedFor: 'Spiritual healers and psychics'
      },
      {
        name: 'Falcon Eye',
        emoji: '🦅',
        description: 'Higher vision stone that connects to Ketu\'s enlightening power.',
        properties: ['Vision', 'Clarity', 'Higher Consciousness'],
        recommendedFor: 'Meditation practitioners and seekers'
      }
    ]
  }
];

// Helper function to get planet by ID
export const getPlanetById = (id) => {
  return planetsData.find(planet => planet.id === id);
};

// Helper function to get all planets
export const getAllPlanets = () => {
  return planetsData;
};

// Helper function to get best stone for a planet
export const getBestStone = (planetId) => {
  const planet = getPlanetById(planetId);
  return planet ? planet.bestStone : null;
};

// Helper function to get all stones for a planet
export const getAllStonesForPlanet = (planetId) => {
  const planet = getPlanetById(planetId);
  if (!planet) return [];
  
  return [planet.bestStone, ...planet.otherStones];
};